export default "__VITE_ASSET__2061f983__"